import { ApiError } from '../errors/api-error.js';
import { BaseApi } from './base.api.js';

export class ChangeRequestApi extends BaseApi {
    constructor(client) {
        super(client, '/change-request');
    }

    async submitForApproval(id, data) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/submit-for-approval`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async approve(id, data = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/approve`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async reject(id, data = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/reject`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
